"use strict";

function productFeatures() {
  var featuresSlider = document.querySelectorAll('.c-product-features__slider');
  if (featuresSlider) {
    featuresSlider.forEach(function (featureSlider) {
      var swiper = new Swiper(featureSlider, {
        spaceBetween: 30,
        slidesPerView: 1,
        // Responsive breakpoints
        breakpoints: {
          // when window width is >= 320px

          350: {
            slidesPerView: 1
          },
          500: {
            slidesPerView: 2,
            spaceBetween: 20
          },
          // when window width is >= 480px
          768: {
            slidesPerView: 3
          },
          // when window width is >= 640px
          1200: {
            slidesPerView: 4
          }
        },
        // Navigation arrows
        navigation: {
          prevEl: '.swiper-button-prev',
          nextEl: '.swiper-button-next'
        }
      });
    });
  }
}
productFeatures();